import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axiosInstance from '../../utils/axiosInstance';
import './Login.css'

const ResetPassword = () => {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const { token } = useParams();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Trim inputs
        const trimmedNewPassword = newPassword.trim();
        const trimmedConfirmPassword = confirmPassword.trim();
        
        // Validation
        if (!trimmedNewPassword || !trimmedConfirmPassword) {
            setMessage('Please fill in all fields');
            return;
        }
        
        if (trimmedNewPassword.length < 8) {
            setMessage('Password must be at least 8 characters long');
            return;
        }
        
        if (trimmedNewPassword !== trimmedConfirmPassword) {
            setMessage('Passwords do not match');
            return;
        }

        // Password strength validation
        const hasUpperCase = /[A-Z]/.test(trimmedNewPassword);
        const hasLowerCase = /[a-z]/.test(trimmedNewPassword);
        const hasNumbers = /\d/.test(trimmedNewPassword);
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(trimmedNewPassword);
        
        if (!hasUpperCase || !hasLowerCase || !hasNumbers || !hasSpecialChar) {
            setMessage('Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character');
            return;
        }

        try {
            // Backend needs the token from the email link to validate the reset request
            const response = await axiosInstance.post('/users/resetPassword', {
                token,
                newPassword: trimmedNewPassword
            });
            
            if (response.status === 200) {
                setMessage('Password reset successful');
                // Redirect to login after 2 seconds
                setTimeout(() => {
            navigate('/Login');
                }, 2000);
            }
        } catch (error) {
            setMessage(error.response?.data?.message || 'Failed to reset password. Please try again.');
        }
    };

    return (
        <div className="reset-password-container">
        <div className="reset-password-box">
            <h1 className="reset-password-title">Reset Password</h1>
            <form onSubmit={handleSubmit} className="reset-password-form">
                <input
                    type="password"
                    placeholder="New Password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    className="reset-password-input"
                />
                <input 
                    type="password"
                    placeholder="Confirm New Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    className="reset-password-input"
                />
                <button type="submit" className="reset-password-button">Reset Password</button>
            </form>
            {message && (
                <div className={`reset-password-message ${message === 'Password reset successful' ? 'success' : 'error'}`}>
                    {message}
                </div>
            )}
        </div>
    </div>
    );
};

export default ResetPassword;